export const fieldsForSearchTrainingReport = {
  date1: {
    key: "date1",
    label: "Период отчета с",
    type: "date",
    disabled: false,
    hidden: false,
    required: true,
  },
  date2: {
    key: "date2",
    label: "Период отчета по",
    type: "date",
    disabled: false,
    hidden: false,
    required: true,
  },
  gims: {
    key: "gims",
    label: "Организация,проводившая обучение",
    type: "selectSearch",
    disabled: false,
    search: false,
    hidden: false,
    required: true,
    placeholder: "Выберите",
    options: [
      { value: 1, label: "ГИМС", key: "gims" },
      { value: 2, label: "Иные", key: "gims" },
    ],
  },
  section: {
    key: "section",
    label: "Участок",
    type: "selectSearch",
    disabled: false,
    required: false,
    hidden: false,
    search: true,
    placeholder: "Все",
    options: [],
  },
  oblast: {
    key: "oblast",
    label: "Область",
    type: "selectSearch",
    disabled: false,
    search: false,
    hidden: false,
    required: false,
    placeholder: "Все",
    options: [],
  },
};

export const setOptionsForFieldTrainingReport = (prop, field) => {
  switch (field) {
    case "firstInit": {
      fieldsForSearchTrainingReport.oblast.options = prop?.filter(
        (el) => el.id !== 5,
      );
      break;
    }
    case "optionsForSection": {
      fieldsForSearchTrainingReport.section.options = prop;
      break;
    }
    case "section": {
      fieldsForSearchTrainingReport.section.disabled = prop;
      break;
    }
    case "oblast": {
      fieldsForSearchTrainingReport.oblast.disabled = prop;
      break;
    }
    default:
      break;
  }
};

export const getOptionsForFieldTrainingReport = () =>
  fieldsForSearchTrainingReport;
